<template>
    <a
      class="purchase-option-group"
      :class="purchaseOptionClasses"
      href="#!"
      @click="selectedHandler"
    >
        <template v-if="view === PurchaseView.default">
            <div class="group-container">
                <div class="plan-container" v-if="subscriptionPlan && !promotionalCode">
                    <Plan
                        :showCurrency="showCurrency"
                        :subscriptionPlan="subscriptionPlan"
                        :active="selected"
                    />
                </div>
                <div class="promo-container" v-if="promotionalCode">
                    <Promo
                            :promotionalCode="promotionalCode"
                            :active="selected"
                    />
                </div>
            </div>
        </template>

        <template v-else-if="view === PurchaseView.token">
            <div class="token-plan-container" :class="{ selected: selected }">
              <div class="header">
                <div class="title">
                  &#128293; {{subscriptionPlan.tokens_quantity}} Tokens
                </div>
                <div class="price">
                  <span class="currency">U$</span> 
                  {{Number(subscriptionPlan.amount * showCurrency.amount_to_usd).toFixed(showCurrency.decimal_precision), showCurrency.symbol}}
                </div>
              </div>
              <div class="description">
                  <h5>{{$t('subscription.payment_type.single', {amount: Number(subscriptionPlan.amount * showCurrency.amount_to_usd).toFixed(showCurrency.decimal_precision), currency_symbol: showCurrency.symbol, currency_description: ''})}}</h5>
              </div>
            </div>
        </template>

        <template v-else-if="view === PurchaseView.paylink">
            <div class="token-plan-container" :class="{ selected: selected }">
              <div class="description">
                  <h3>&#128184; {{ subscriptionPlan.title }} </h3>
                  <h5>
                    {{ 
                      $t(
                        'subscription.payment_type.send', 
                        {
                          amount: Number(subscriptionPlan.amount * showCurrency.amount_to_usd).toFixed(showCurrency.decimal_precision), 
                          currency_symbol: showCurrency.symbol, 
                          webstar: $route.params.username
                        }
                      )
                    }}
                  </h5>
              </div>
              <div class="price">
                  <span class="currency">U$</span> 
                  {{Number(subscriptionPlan.amount * showCurrency.amount_to_usd).toFixed(showCurrency.decimal_precision), showCurrency.symbol}}
              </div>
            </div>
        </template>
    </a>
</template>
<script>
import { PurchaseView } from "../../types/enums";
import Plan from "./SubscriptionForm.Plan";
import Promo from "./SubscriptionForm.Promo";

export default {
  components: {
    Plan,
    Promo,
  },
  props: {
    purchaseOption: {
      type: Object,
      required: true,
    },
    showCurrency: {
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    view: {
      required: false,
      type: String,
      default: PurchaseView.default,
    },
  },
  data() {
    return {
      PurchaseView,
    };
  },
  methods: {
    selectedHandler(e) {
      e.preventDefault();
      this.$emit("selected", this.purchaseOption);
    },
  },
  computed: {
    promotionalCode() {
      return this.purchaseOption.promotional_code
        ? this.purchaseOption.promotional_code.data
        : null;
    },
    subscriptionPlan() {
      return this.purchaseOption.subscription_plan
        ? this.purchaseOption.subscription_plan.data
        : null;
    },
    hasBoth() {
      return this.promotionalCode && this.subscriptionPlan;
    },
    purchaseOptionClasses() {
      return {
        "free-trial":
          this.promotionalCode && !!this.promotionalCode.type_is_free_trial,
        "has-both": this.hasBoth,
      };
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../styles/variables";

.purchase-option-group {
  .group-container {
    margin-bottom: 15px;
    position: relative;
  }

  /*
        .payment-methods-wrapper{
            pointer-events:none;
            position: absolute;
            height: 100%;
            right: 0;
            bottom: 0;
            top: 0;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: flex-end;

            @media(max-width: 600px) {
                display:none;
            }


            .payment-method{
                width: 40px;
                height: 40px;
                box-shadow: 1px 1px 4px rgba(0,0,0,.35);
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                background-color: var(--pallete_secondary_color);

                &:not(:first-child){
                    margin-top: 7.5px;
                }
            }
        }
        */
}

.token-plan-container {
  align-items: center;
  background-color: var(--pallete_dark_color);
  border: solid 1px white;
  border-radius: 1rem;
  display: flex;
  font-size: 1.2rem;
  flex-direction: column;
  padding: 0.75rem 1.5rem;
  margin-bottom: 1rem;
  transition: border 1s ease-out 10ms;

  .header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 1em;


    .title {
      display: block;
      padding: 0;
      margin: 0;
      margin-block: auto;

      font-size: 1.5rem;
      font-weight: bold;
      unicode-bidi: isolate;
    }

    .price {
      margin-block: auto;

      color: var(--pallete_main_color);
      font-size: 1.5rem;
      font-weight: bold;
    }
  }

  &:hover, &.selected {
    border: solid 1px var(--pallete_main_color);
  }

  .description {
    flex: 1;
    width: 100%;
  }

  h5 {
    padding: 0;
    // margin: 1rem 0 1rem 0.5rem;
    margin: 0;
  }

  .currency {
    font-size: 1rem;
  }
}
</style>
